import 'core-js/modules/es6.set';
import 'core-js/modules/es6.map';
import 'raf/polyfill';
import './src/css/custom-tailwind.css';

export const onServiceWorkerUpdateReady = () => window.location.reload();